/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Greek (Greece): el-gr
 */

/**
 * Translation file for el-GR locale
 *
 * @file el.js
 * @author Mohamed yasar arabath M
 */

const el = {
  'popularChannelSlider.allChannels': 'Όλα τα κανάλια',
  'popularChannelSlider.recommended': 'Συνιστώμενα',
  'hero.myetextbook.link': 'βιβλιοθήκη',
  'hero.myetextbook.text': 'Δεν είναι ο σωστός τίτλος; Απόκτησε πρόσβαση στο ηλεκτρονικό βιβλίο σου.',
  'hero.etextfeaturestitle': 'Βρες υλικό μελέτης στο ηλεκτρονικό βιβλίο σου.',
  'hero.etextfeaturesdescription': 'Το ηλεκτρονικό βιβλίο σου διαθέτει εξαρχής υλικό μελέτης που είναι σχεδιασμένο για να βοηθήσει να φτάσεις στην επιτυχία. Μελέτησε με εκπαιδευτικές κάρτες και πολλά άλλα χωρίς να φύγεις από το ηλεκτρονικό βιβλίο σου.',
  'aichat.title1': 'Βρες βοήθεια με τεχνολογία AI για οτιδήποτε όσον αφορά το συγκεκριμένο ηλεκτρονικό βιβλίο.',
  'aichat.chatDesc1': 'Πληκτρολόγησε μια ερώτηση για αρχή.',
  'subscriptiontext.isSubscribed': 'Μέρος της συνδρομής σου',
  'subscriptiontext.nonSubscriber': 'Αναβάθμιση για πλήρη πρόσβαση',
  'topicConatiner.otherHeader': 'Σχετικά βίντεο και εξάσκηση',
  'topicConatiner.exactLiteHeader': 'Σχετικές έννοιες και εξάσκηση',
  'moremenu.downloadApp': 'Λήψη της εφαρμογής',
  'moremenu.downloadAppAlreadyDownload': '%Click here% για λήψη της εφαρμογής σε κάποια άλλη συσκευή και αυτόματη είσοδο ή για χρήση του αποκλειστικού σου κωδικού QR για ασφαλή είσοδο στην εφαρμογή που έχεις ήδη εγκαταστήσει.',
  'moremenu.downloadAppNotDownload': '%Click here% για λήψη της εφαρμογής και ασφαλή είσοδο με χρήση του αποκλειστικού σου κωδικού QR.',
  'channel.noBundletitle': 'Χρησιμοποίησε το Study Prep για θέματα που έχουν σχέση με τον κύκλο των μαθημάτων σου και άλλους κύκλους.',
  'onboard.studyPlan': 'Το εξατομικευμένο πρόγραμμα μελέτης δημιουργήθηκε!',
  'onboard.addCourseAnother': 'Θέλεις να προσθέσεις κάποιον άλλο κύκλο μαθημάτων;',
  'onboard.purchase': 'Χρειάζεται να αγοράσω ένα ηλεκτρονικό βιβλίο της Pearson.',
  'onboard.addCourseWithoutEtext': 'Προσθήκη κύκλου μαθημάτων με χρήση του Study Prep',
  'onboard.mayBeLater': 'Ίσως αργότερα',
  'onboard.aboutCourse': 'Πες μας για τον κύκλο των μαθημάτων σου.',
  'onboard.close': 'Κλείσιμο',
  'course.addTitle': 'Προσθήκη κύκλου μαθημάτων',
  'common.PURCHASE': 'Αγορά',
  'common.CLOSE': 'Κλείσιμο',
  'open': 'άνοιγμα',
  'continue': 'Συνέχεια',
  'yes': 'Ναι',
  'no': 'Όχι',
  'audio': 'Αρχείο ήχου',
  'courses.toc.PUBLISH_SUCCESS': 'Επιτυχία!',
  'courses.toc.PUBLISH_MESSAGE': 'Οι μαθητές θα δουν τις αλλαγές σου την επόμενη φορά που θα ανοίξουν το περιεχόμενο.',
  'errors.GENERIC_TITLE': 'Δεν έχεις πρόσβαση αυτή τη στιγμή.',
  'errors.GENERIC_DESC': 'Καταρχάς, ανανέωσε ή εκκαθάρισε την cache σου. Αν αυτό δεν φέρει αποτελέσματα, επικοινώνησε με το Τμήμα ',
  'errors.GENERIC_LINK': 'Υποστήριξης της Pearson.',
  'errors.GENERIC_CODE': 'Κωδικός σφάλματος: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Η συνδρομή δεν βρέθηκε.',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Ο λογαριασμός σου δεν περιλαμβάνει δικαίωμα πρόσβασης στον συγκεκριμένο τίτλο. Αν πιστεύεις ότι έχεις λάβει το μήνυμα αυτό κατά λάθος, θα πρέπει να επικοινωνήσεις με το Τμήμα Τεχνικής Υποστήριξης της Pearson.',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Η συνδρομή δεν βρέθηκε.',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Η συνδρομή σου δεν περιλαμβάνει δικαίωμα πρόσβασης στο ηλεκτρονικό βιβλίο, αλλά μπορείς να εγγραφείς στην υπηρεσία αυτή τώρα χρησιμοποιώντας μια πιστωτική κάρτα.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/higher-education/products-services-teaching/course-content/textbooks-and-etexts/pearson-etext/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Ο λογαριασμός μου',
  'menu.helpCenter': 'Κέντρο βοήθειας',
  'menu.preferencesCenter': 'Κέντρο προτιμήσεων',
  'menu.CONTACT_SUPPORT': 'Επικοινωνία με το Τμήμα Υποστήριξης',
  'menu.HELP_SUPPORT': 'Βοήθεια και υποστήριξη',
  'menu.FAQS': 'Συχνές ερωτήσεις',
  'menu.CHAT_WITH_SUPPORT': 'Συνομιλία με το Τμήμα Υποστήριξης',
  'menu.OTP_CODES': 'Κωδικοί OTP',
  'menu.LAUNCH_CODE': 'Εκκίνηση αρχείου καταγραφής κωδικών',
  'menu.SEND_CODE': 'Αποστολή νέου κωδικού στον χρήστη μέσω email',
  'menu.SEND_CODE_PHONE': 'Αποστολή νέου κωδικού στον χρήστη μέσω μηνύματος κειμένου',
  'menu.LEGAL': 'Νομικά θέματα',
  'menu.PRIVACY_NOTICE': 'Δήλωση απορρήτου',
  'menu.TITLE_INFO': 'Πληροφορίες για τον τίτλο',
  'menu.PEARSON_ACCESSIBILITY': 'Προσβασιμότητα Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Δήλωσε {deviceLimit} συσκευές; Κάνε 1 εναλλαγή τον μήνα.',
  'menu.ACCESSIBILITY': 'Προσβασιμότητα',
  'menu.ACCESSIBILITY_SUPPORT': 'Υποστήριξη προσβασιμότητας',
  'menu.DEVICES': 'Πρόσφατες συσκευές',
  'menu.THIS_DEVICE': 'Αυτή η συσκευή',
  'menu.GET_THE_APP_DOWNLOAD': 'Λήψη της εφαρμογής για κινητές συσκευές',
  'menu.MOJO_APP_INFO': 'Πήγαινε στο κατάστημα εφαρμογών στο τηλέφωνο ή στο tablet σου για να χρησιμοποιήσεις την εφαρμογή Pearson+ χωρίς σύνδεση.',
  'menu.DEVICE_LABEL': 'Συσκευή',
  'menu.DEVICE_DISCONNECT': 'Αποσύνδεση',
  'menu.FOXIT': 'Παρέχεται από τη Foxit.',
  'menu.TERMS_OF_USE': 'Όροι χρήσης',
  'menu.SIGN_OUT': 'Έξοδος',
  'menu.PRINT_PAGE': 'Εκτύπωση σελίδας',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. All Rights Reserved.',
  'print.FOOTER_MESSAGE': 'Τυπώθηκε από {fullName}({email}) στις {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Έχεις ήδη κάνει εναλλαγή αυτόν τον μήνα.',
  'device.SWITCH_DEVICE': 'Μετάβαση στην τρέχουσα συσκευή;',
  'device.SWITCH_ONCE': 'Επειδή μπορείς να κάνεις αλλαγή μόνο μία φορά τον μήνα, δεν θα έχεις τη δυνατότητα να αναιρέσεις την ενέργεια αυτή.',
  'device.SEAT_TAKEN': 'Η θέση αυτή είναι πιασμένη.',
  'device.DISCONNECT_DEVICE': 'Μπορείς να συνδεθείς μόνο σε 3 συσκευές. Για να συνεχίσεις εδώ, αποσύνδεσε κάποια άλλη συσκευή.',
  'device.ALERT_TEXT': 'Θα πρέπει να θυμάσαι ότι μπορείς να κάνεις εναλλαγή συσκευών μόνο μία φορά τον μήνα.',
  'device.DISCONNECT': 'Αποσύνδεση',
  'device.CONTINUE': 'Συνέχεια',
  'device.HEADER': 'Τερματισμός της περιόδου λειτουργίας του άλλου προγράμματος περιήγησής σου;',
  'device.CLOSE': 'Επιστροφή στην αρχική σελίδα',
  'device.CODE': 'Συνέχισε εδώ καταχωρώντας τον κωδικό ελέγχου ταυτότητας που στάλθηκε στο {maskedEmail}. Δεν λύθηκε το πρόβλημα; Έλεγξε τον φάκελο της ανεπιθύμητης αλληλογραφίας σου, ζήτησε {email} ή επικοινώνησε με το {support}.',
  'device.TIMER': 'Έχεις {time} για να καταχωρήσεις τον κωδικό σου εδώ.',
  'device.RESEND': '{resend}',
  'device.FAQ': 'Συχνές ερωτήσεις',
  'device.RESEND_NAME': 'Επαναποστολή',
  'device.NOTE': 'Αν χρησιμοποιείς τακτικά το Pearson+ σε 2 μέρη, π.χ. στη δουλειά και στο σχολείο, φρόντιζε να αποσυνδέεσαι όποτε τελειώνεις. Επίσης, μπορείς να χρησιμοποιείς την εφαρμογή Pearson+ για κινητές συσκευές σε έως και 2 συσκευές. Για περισσότερες πληροφορίες, ανάτρεξε στην ενότητά μας {faq}.',
  'device.NOTE_HEADER': 'Αποφυγή αυτή τη φορά',
  'device.CONTACT_SUPPORT': 'Τμήμα Υποστήριξης Πελατών',
  'device.CONTACT_EMAIL': 'ενημέρωση της διεύθυνσης email σου',
  'device.INCORRECT': 'Λάθος. Έλεγξε ξανά τον κωδικό σου ή ζήτησε να σου σταλεί ξανά.',
  'device.MANY_ATTEMPTS': 'Πάρα πολλές προσπάθειες. Δοκίμασε να ζητήσεις επαναποστολή του κωδικού.',
  'device.EXPIRED': 'Ο χρόνος σου έληξε. Δοκίμασε να ζητήσεις επαναποστολή του κωδικού.',
  'device.ACCESS_HEADER': 'Είσαι μέσα!',
  'device.ACCESS_DESC': 'Η περίοδος λειτουργίας σου έχει πιστοποιηθεί. Θέλεις να ενημερώσεις τον κωδικό πρόσβασής σου όσο βρίσκεσαι εκεί;',
  'device.ACCESS_CHANGE_PASSWORD': 'Αλλαγή κωδικού πρόσβασης',
  'device.ACCESS_RESET_PASSWORD': 'Επαναφορά κωδικού πρόσβασης',
  'device.THREATONE_TITLE': 'Όλα καλά;',
  'device.THREATONE_DESC': 'Παρατηρούμε κάποια ύποπτη δραστηριότητα στον λογαριασμό σου.',
  'device.THREATONE_DESC_TWO': 'Τώρα είναι μια καλή στιγμή να αλλάξεις τον κωδικό σου.',
  'device.MAY_BE_LATER': 'Ίσως αργότερα',
  'device.OKAY': 'Εντάξει',
  'device.ACCOUNT_LOCK_DESC': 'Για λόγους διατήρησης της ασφάλειας, σε αποσυνδέουμε. Έχουμε στείλει έναν σύνδεσμο επαναφοράς κωδικού πρόσβασης στη διεύθυνση email που είναι συσχετισμένη με τον λογαριασμό σου.',
  'device.ACCOUNT_LOCK_TITLE': 'Παρατηρήσαμε κάποια ύποπτη δραστηριότητα στον λογαριασμό σου.',
  'device.ACCOUNT_LOCK_TIMER': 'Θα αποσυνδεθείς σε {time}.',
  'navigation.PAGE': 'Σελίδα',
  'launchcode.CREATEBY': 'Δημιουργία από:',
  'launchcode.sentvia': 'Στάλθηκε μέσω:',
  'launchcode.CODEINLAST': 'Κωδικοί τις τελευταίες 7 ημέρες:',
  'launchcode.TIMESENT': 'Ώρα αποστολής: ',
  'launchcode.ACCOUNTEMAIL': 'Διεύθυνση email λογαριασμού:',
  'launchcode.LAUNCHDIALOGTITLE': 'Αρχείο καταγραφής κωδικών OTP',
  'textmessage.TITLE': 'Καταχώρηση αριθμού τηλεφώνου',
  'textmessage.PHONE_NUMBER': 'Αριθμός τηλεφώνου',
  'textmessage.SEND_CODE': 'Αποστολή κωδικού',
  'textmessage.INVALID_NUMBER': 'Μη έγκυρος αριθμός τηλεφώνου.',
  'textmessage.SUCCESS_MESSAGE': 'Στάλθηκε κωδικός.',
  'remove.title': 'Κατάργηση τίτλου;',
  'remove.subTitle': 'Μπορείς πάντα να τον επαναφέρεις αργότερα – απλώς χρησιμοποίησε τη δυνατότητα αναζήτησης και πρόσθεσέ τον ξανά.',
  'remove.buttonText': 'Κατάργηση',
  'search.searchPlaceHolderPPlus': 'Αναζήτηση βάσει ISBN, τίτλου ή συγγραφέα',
  'search.searchPlaceHolderEText': 'Αναζήτηση στη βιβλιοθήκη σου',
  'footer.downloadMobileApp': 'Λήψη της εφαρμογής για κινητές συσκευές',
  'footer.termsOfUse': 'Όροι χρήσης',
  'footer.privacy': 'Απόρρητο',
  'footer.cookies': 'Cookie',
  'footer.doNotSellMyPersonalInformation': 'Να μην πωληθούν οι προσωπικές πληροφορίες μου.',
  'footer.accessibility': 'Προσβασιμότητα',
  'footer.patentNotice': 'Γνωστοποίηση διπλώματος ευρεσιτεχνίας',
  'footer.copyrights': 'Pearson Με επιφύλαξη κάθε νόμιμου δικαιώματος.',
  'hero.toc.defaultPlacehoder': '--- Επίλεξε ένα θέμα. ---',
  'hero.openEtextBookV1': 'Άνοιγμα ηλεκτρονικού βιβλίου',
  'hero.heroHeading': 'Επειδή μελετάς <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Εφαρμογή Study Prep',
  'hero.study.help': 'Λήψη βοήθειας στη μελέτη',
  'hero.study.jumpBackIn': 'Μεταπήδηση πίσω σε',
  'hero.study.numOfUsers': 'Αυτή τη στιγμή υπάρχουν <b>{num_of_users}</b> που χρησιμοποιούν τα κανάλια.',
  'hero.heroChannel.cardsHeading': 'Συνέχισε από εκεί όπου σταμάτησες.',
  'hero.marketingcard1.copy.title': 'Μάθε με βίντεο.',
  'hero.marketingcard1.copy.description': 'Δες μικρά βίντεο με επεξηγήσεις που αναλύουν δύσκολα θέματα.',
  'hero.marketingcard2.copy.title': 'Προβλήματα εξάσκησης',
  'hero.marketingcard2.copy.description': 'Προετοιμάσου για την εξέτασή σου με χιλιάδες ερωτήσεις όπως στις εξετάσεις και λύσεις με βίντεο.',
  'hero.marketingcard3.copy.title': 'Βρες βοήθεια από έμπειρους εκπαιδευτικούς.',
  'hero.marketingcard3.copy.description': 'Δημοσίευσε ερωτήσεις και πάρε απαντήσεις από ειδικούς σε κάθε θέμα.',
  'hero.popularTopics.heading': 'Άλλα δημοφιλή θέματα στο κανάλι αυτό',
  'hero.popularChannels.headingv1': 'Πρόκειται να πάρεις κάποιον άλλο κύκλο μαθημάτων;',
  'hero.popularChannels.descriptionv2': 'Περιηγήσου σε δημοφιλή θέματα βοήθειας στη μελέτη.',
  'hero.practice': 'Εξάσκηση',
  'hero.herobook.mappedChannelHeading': 'Συνιστώμενη βοήθεια στη μελέτη στο κανάλι αυτό',
  'libraryL2.myBooks': 'Τα βιβλία μου',
  'libraryL2.archived': 'Αρχειοθετήθηκε.',
  'libraryL2.back': 'Πίσω',
  'hero.practiceProblem': 'Πρόβλημα εξάσκησης',
  'nativeAppBanner.drawer.title': 'Άνοιγμα σε...',
  'nativeAppBanner.drawer.pearsonApp': 'Εφαρμογή Pearson+',
  'nativeAppBanner.banner.title': 'Εφαρμογή Pearson+',
  'nativeAppBanner.banner.description': 'Μάθηση εν κινήσει',
  'hero.promotionalcard.list1': 'Μικρά βίντεο που αναλύουν δύσκολα θέματα',
  'hero.promotionalcard.list2': 'Χιλιάδες ερωτήσεις όπως στις εξετάσεις',
  'hero.promotionalcard.list3': 'Πάρε απαντήσεις από ειδικούς σε κάθε θέμα.',
  'hero.studyandexamprep': 'Εφαρμογή Study Prep',
  'hero.heroBook.sectionSubHeadingV1': 'Ανάλυσε δύσκολα θέματα με επεξηγήσεις μέσω βίντεο και ερωτήσεις εξάσκησης προσαρμοσμένες στον κύκλο των μαθημάτων σου.',
  'hero.heroBook.sectionSubHeadingV2': 'Ανάλυσε δύσκολα θέματα με επεξηγήσεις εννοιών και ερωτήσεις εξάσκησης προσαρμοσμένες στον κύκλο των μαθημάτων σου.',
  'hero.SeeAllStudyOptions': 'Προβολή όλων των επιλογών μελέτης',
  'hero.herobook.mappedChannelHeadingV1': 'Συνιστώμενα βίντεο και ερωτήσεις εξάσκησης',
  'hero.popularTopics.headingV1': 'Άλλα δημοφιλή θέματα',
  'hero.heroHeadingV1': 'Για <span>{replace_value}</span>',
  'hero.learnmore': 'Περισσότερες πληροφορίες',
  'hero.eTextbook': 'Ηλεκτρονικό βιβλίο',
  'hero.goToPage.label': 'Μετάβαση στη σελίδα',
  'subscription.studyTitle': 'Εφαρμογή Study Prep',
  'print.printAvailTitle': 'Θέλεις να εκτυπώσεις τη σελίδα αυτή; Να πώς',
  'print.printAvailDesc': 'Στο ηλεκτρονικό βιβλίο σου, επίλεξε το εικονίδιο του λογαριασμού επάνω δεξιά. Από τις επιλογές, επίλεξε τη δυνατότητα «Εκτύπωση σελίδας» και ύστερα επίλεξε τις ρυθμίσεις για την εκτύπωσή σου.',
  'print.printNotAvailTitle': 'Η επιλογή εκτύπωσης για το συγκεκριμένο ηλεκτρονικό κείμενο δεν είναι ενεργοποιημένη.',
  'print.printNotAvailDesc': 'Για άνετη πρόσβαση χωρίς σύνδεση, προχώρα στη λήψη του τίτλου σου μέσω της εφαρμογής Pearson+ για κινητές συσκευές και απόλαυσε την ευελιξία της μελέτης ανά πάσα στιγμή, οπουδήποτε!',
  'hero.header.cta': 'Μετάβαση στα εργαλεία μελέτης',
  'hero.header.ctav2': 'Άνοιγμα του Study Prep',
  'hero.marketing.title': 'Εύρεση του ηλεκτρονικού βιβλίου σου',
  'hero.marketing.subTitle': 'Επίλεξε τίτλους από άνω των 2.000 ηλεκτρονικά βιβλία με αρχεία ήχου, εκπαιδευτικές κάρτες, σημειώσεις και πολλά άλλα. Μόνο 10,99 $/μήνα για περίοδο 4 μηνών.',
  'hero.popularchannels.desc': 'Βρες βοήθεια στη μελέτη με τα κορυφαία αυτά θέματα.',
  'hero.removecourse.title': 'Κατάργηση του κύκλου μαθημάτων από τον πίνακα εργαλείων;',
  'hero.removecourse.description': 'Μπορείς πάντα να προσθέσεις ξανά αυτόν τον κύκλο μαθημάτων στον πίνακα εργαλείων σου κάνοντας κλικ στην επιλογή «Προσθήκη κύκλου μαθημάτων».',
  'hero.removecourse.primaryCtaText': 'Κατάργηση',
  'hero.removecourse.secondaryCtaText': 'Ακύρωση',
  'hero.tableOfContents': 'Πίνακας περιεχομένων',
  'hero.search': 'Αναζήτηση',
  'hero.emptystate.cta': 'Αναζήτηση ηλεκτρονικών βιβλίων',
  'hero.watch_it_again': 'Παρακολούθηση ξανά',
  'hero.mondly.learnLang.title': 'Εκμάθηση μιας νέας γλώσσας δωρεάν',
  'hero.mondly.subTitle': 'Οι χρήστες των ηλεκτρονικών βιβλίων της Pearson παίρνουν δωρεάν τρεις μήνες του Mondly από την Pearson.',
  'hero.mondly.description': 'Οι περισσότερες εφαρμογές εκμάθησης γλωσσών σού επιτρέπουν να μάθεις μόνο από τα Αγγλικά. Αλλά είναι καλύτερο να μάθεις από τη μητρική σου γλώσσα, οπότε το Mondly σου δίνει τη δυνατότητα εκμάθησης από οποιαδήποτε από τις <strong>41 γλώσσες μας</strong>.',
  'hero.mondly.startLearningCTA': 'Έναρξη εκμάθησης',
  'hero.mondly.marketing.bestApp': 'Η καλύτερη εφαρμογή',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Εφαρμογή της χρονιάς',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart – Νικητής 2017 στην περιοχή EMEA',
  'hero.mondly.marketing.editorChoice': 'Επιλογή προγράμματος επεξεργασίας',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Εκμάθηση μιας γλώσσας',
  'header.menu.moreAtPearson': 'Περισσότερα στην Pearson',
  'hero.subscriptionStatusTitle2': 'Οι πόροι σου από το Pearson+',
  'hero.startStudying': 'Έναρξη μελέτης',
  'onboard.studyMaterials': 'Επίλεξε το θέμα σου και θα δημιουργήσουμε έναν πίνακα εργαλείων με εξατομικευμένο υλικό μελέτης.',
  'hero.myETextbooks': 'Τα ηλεκτρονικά βιβλία μου',
  'header.continueInTheApp': 'Συνέχεια στην εφαρμογή',
  'hero.learnTxt': 'Μάθηση',
  'hero.examPrepTxt': 'Προετοιμασία για τις εξετάσεις',
  'hero.aITutorTxt': 'Σύμβουλος AI',
  'AI.toolTip': 'Ρώτα με για οτιδήποτε στο ηλεκτρονικό βιβλίο σου.',
  'hero.studyExamPrepAllYourCourses': 'Study Prep για όλους τους κύκλους μαθημάτων σου',
  'header.qrCode.subHeaderTxt': 'Χρησιμοποίησε αυτόν τον κωδικό QR για γρήγορη και ασφαλή είσοδο στην εφαρμογή Pearson+ στην κινητή συσκευή σου.',
  'header.qrCode.dontHaveApp': 'Δεν έχεις την εφαρμογή;',
  'header.qrCode.footerTxt': 'Σαρώνοντας αυτόν τον κωδικό θα ανακατευθυνθείς στο App Store ή στο Google Play. Μόλις ολοκληρωθεί η λήψη της εφαρμογής, συνδέσου σαρώνοντάς τον ξανά.',
  'header.qrCode.errorMsg': 'Ο κωδικός QR δεν φορτώθηκε. Κλείσε τη σελίδα και προσπάθησε ξανά.',
  'hero.yourETextbook': 'Το βιβλίο σου',
  'onboard.addCourseWithEtextBundle': 'Προσθήκη κύκλου μαθημάτων με χρήση του Study Prep',
  'onboard.disableTooltipText': 'Έχουν προστεθεί όλοι οι κύκλοι μαθημάτων του Study Prep!',
  'subscriptionstatus.bundlecta': 'Πρόσβαση στο Study Prep',
  'subscriptionstatus.nonbundlecta': 'Πρόσβαση στο Study Prep',
  'channel.genericBundle': 'Χρησιμοποίησε το Study Prep σου για βοήθεια στους υπόλοιπους κύκλους μαθημάτων σου.',
  'channel.relatedBundle': 'Επίσης, χρησιμοποίησε το Study Prep σου για βοήθεια στους υπόλοιπους κύκλους μαθημάτων σου.',
  'onboard.courseAdded': 'Ο κύκλος μαθημάτων προστέθηκε!',
  'hero.flashcards': 'Εκπαιδευτικές κάρτες',
  'relatedChannelCard.title': 'Βελτίωσε τη μάθησή σου με αυτόν τον σχετικό πόρο.',
  'relatedChannelCard.badgeText': 'Study Prep για σχετικά θέματα',
  'sessionInactivity.title': 'Είσαι ακόμη εδώ;',
  'sessionInactivity.description': 'Η συνεδρία σου θα λήξει σε <b>%TIMER%</b> λόγω αδράνειας.<br/>Θέλεις να παραμείνεις σε σύνδεση;',
  'sessionInactivity.keepMeSignIn': 'Να παραμείνω σε σύνδεση.',
  'sessionInactivity.signOut': 'Έξοδος',
  'sessionTimeout.title': 'Η συνεδρία έληξε.',
  'sessionTimeout.description': 'Η συνεδρία σου έχει λήξει λόγω αδράνειας.',
  'print.qrCode.header': 'Χρησιμοποίησε αυτόν τον κωδικό QR για να ανοίξεις την εφαρμογή Pearson+ στην κινητή συσκευή σου.',
  'print.qrCode.footer': 'Σαρώνοντας αυτόν τον κωδικό θα ανακατευθυνθείς στο App Store ή στο Google Play. Μόλις ολοκληρωθεί η εγκατάσταση της εφαρμογής, συνδέσου για λήψη και προσπέλαση του τίτλου σου.',
  'hero.nestest.title': 'Προετοιμάσου για την εξέταση πιστοποίησης εκπαιδευτικού.',
  'hero.nestest.subTitle': 'Οι χρήστες του Pearson+ μπορούν πλέον να αποκτούν πρόσβαση σε εθνικά ευθυγραμμισμένους κύκλους μαθημάτων προετοιμασία και τεστ εξάσκησης στο πλαίσιο της προετοιμασίας τους για τις εξετάσεις πιστοποίησης εκπαιδευτικού.',
  'hero.channelAI.title': 'Χρειάζεσαι βοήθεια Ο σύμβουλος AI σε καλύπτει.',
  'hero.channelAI.desc': 'Κάνε μια ερώτηση και βρες βοήθεια βήμα προς βήμα για την εργασία σου στο σπίτι, συστάσεις για τη μελέτη και πολλές άλλες λύσεις – προσωπικοποιημένη βοήθεια όποτε τη χρειάζεσαι.',
  'hero.channelAI.action': 'Ρώτα τον σύμβουλο AI τώρα.',
  'new': 'Νέο!',
  'hero.practice.numOfUsers': 'Η ενότητα αυτή έχει <b>{practice_num_of_users}</b> προβλήματα εξάσκησης.',
  'hero.practice.cta': 'Εξασκήσου τώρα.',
  'hero.practice.title': 'Πρόβλημα εξάσκησης',
  'diagnostics.errorMsg': 'Ο διαγνωστικός έλεγχος δεν φορτώθηκε. Κλείσε τη σελίδα και προσπάθησε ξανά.',
  'qrcode.title': 'Άρχισε να μελετάς όπου κι αν βρίσκεσαι.',
  'qrcode.subtitle': 'Μάθηση οπουδήποτε, ανά πάσα στιγμή, με την εφαρμογή Pearson+ για κινητές συσκευές. Πραγματοποίησε τη λήψη της τώρα και ξεκλείδωσε μια απρόσκοπτη εμπειρία μάθησης.',
  'qrcode.detailsv1': 'Με την εφαρμογή Pearson+, μπορείς να χρησιμοποιήσεις αυτόν τον κωδικό QR για να συνεχίσεις από εκεί όπου σταμάτησες. Αναζήτηση στο βιβλίο σου, μελέτη με εκπαιδευτικές κάρτες, παρακολούθηση βιντεομαθημάτων και πολλά άλλα όπου κι αν πας.',
  'qrcode.detailsv2': 'Σάρωσε αυτόν τον κωδικό QR όποτε θέλεις να συνδεθείς γρήγορα και να συνεχίσεις ακριβώς από εκεί όπου σταμάτησες.',
  'qrcode.details': 'Με την εφαρμογή Pearson+, μπορείς να χρησιμοποιήσεις αυτόν τον κωδικό QR για να συνεχίσεις από εκεί όπου σταμάτησες.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Μάθηση οπουδήποτε, ανά πάσα στιγμή, με την εφαρμογή Pearson+ για κινητές συσκευές. Πραγματοποίησε τη λήψη της τώρα και ξεκλείδωσε μια απρόσκοπτη εμπειρία μάθησης.',
  'install': 'Install',
  'header.menu.createCourse': 'Νέος κύκλος μαθημάτων',
  'header.dropdown.courses': 'Κύκλοι μαθημάτων',
  'header.dropdown.recentlyViewed': 'Πρόσφατα προβεβλημένα',
  'header.dropdown.viewAll': 'Προβολή όλων των κύκλων μαθημάτων',
  'aet.courseHeader.inviteStudents': 'Πρόσκληση μαθητών',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Προσκάλεσε μαθητές να αποκτήσουν πρόσβαση στο συγκεκριμένο ηλεκτρονικό βιβλίο αντιγράφοντας τη διεύθυνση του συνδέσμου ή τις οδηγίες παρακάτω στο email ή στο πρόγραμμα σπουδών σου.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Διεύθυνση συνδέσμου',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Αντιγραφή συνδέσμου',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Οδηγίες με διεύθυνση συνδέσμου',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Αντιγραφή οδηγιών',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Θα σου ζητηθεί να συνδεθείς μέσω του υπάρχοντος λογαριασμού σου στην Pearson. Αν δεν έχεις λογαριασμό στην Pearson, θα μπορέσεις να δημιουργήσεις έναν.  ',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Ημερομηνία έναρξης:',
  'aet.courseHeader.endDate': 'Ημερομηνία λήξης:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Μορφή:',
  'aet.home.manageroster': 'Διαχείριση καταλόγου ονομάτων',
  'aet.home.managegradesync': 'Διαχείριση συγχρονισμού βαθμών',
  'aet.home.copycourse': 'Αντιγραφή κύκλου μαθημάτων',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'Τρέχουσα',
  'aet.instructorCourse.tabs.past': 'Στο παρελθόν',
  'aet.instructorCourse.tabs.courseSettings': 'Ρυθμίσεις κύκλου μαθημάτων',
  'aet.instructorCourse.tabs.manageRoster': 'Διαχείριση καταλόγου ονομάτων',
  'aet.instructorCourse.currentCourses.title': 'Τρέχοντες κύκλοι μαθημάτων',
  'aet.instructorCourse.pastCourses.title': 'Παλαιότεροι κύκλοι μαθημάτων',
  'aet.instructorCourse.createOrCopy.title': 'Δημιουργία ή αντιγραφή κύκλου μαθημάτων',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Αντιγραφή κύκλου μαθημάτων άλλου εκπαιδευτικού ή δημιουργία νέου',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Αντιγραφή κύκλου μαθημάτων άλλου εκπαιδευτικού',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Καταχώρησε το αναγνωριστικό του κύκλου μαθημάτων για να βρεις αυτόν που θέλεις να αντιγράψεις.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Αναγνωριστικό κύκλου μαθημάτων',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Καταχώρησε το αναγνωριστικό του κύκλου μαθημάτων.',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Έκανες αναζήτηση για',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Δημιουργία νέου κύκλου μαθημάτων από τον κατάλογο',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Αναζήτηση βάσει τίτλου, συγγραφέα, ISBN ή λέξεων-κλειδιών για το θέμα.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Αναζήτηση...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Εμφάνιση περισσότερων',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Εμφάνιση λιγότερων',
  'aet.instructorCourse.cancel': 'Ακύρωση',
  'aet.instructorCourse.loading': 'Φόρτωση...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Συγχρονισμός βαθμών',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Διαχείριση συγχρονισμού βαθμών',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Ονομασία κύκλου μαθημάτων',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Χωρίς τίτλο',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Ονομασία ενότητας',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Χωρίς τίτλο',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Ίδρυμα',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Απαιτείται η καταχώρηση ιδρύματος.',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Παρουσιάστηκε κάποιο πρόβλημα. Προσπάθησε ξανά.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Δεν βρέθηκε κανένα αποτέλεσμα.',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Ημερομηνία έναρξης κύκλου μαθημάτων',
  'aet.instructorCourse.courseForm.endDateLabel': 'Ημερομηνία λήξης κύκλου μαθημάτων',
  'aet.instructorCourse.courseForm.datePlaceholder': 'ηη/μμ/εε',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Να επιτρέπεται σε άλλους η αντιγραφή αυτού του κύκλου μαθημάτων.',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Κοινή χρήση του κωδικού με τους εκπαιδευτικούς που θέλουν να αντιγράψουν αυτόν τον κύκλο μαθημάτων',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Κωδικός αντιγραφής',
  'aet.instructorCourse.courseForm.optionalSuffix': '(προαιρετικά)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Η φόρμα έχει σφάλματα επικύρωσης.',
  'aet.instructorCourse.courseForm.submitContinue': 'Συνέχεια',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Αποθήκευση...',
  'aet.instructorCourse.courseForm.submitError': 'Δεν μπορέσαμε να δημιουργήσουμε τον κύκλο μαθημάτων σου. Προσπάθησε ξανά.',
  'aet.instructorCourse.courseForm.submitEditError': 'Δεν μπορέσαμε να αποθηκεύσουμε τις αλλαγές σου. Προσπάθησε ξανά.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Αποθήκευση αλλαγών',
  'aet.instructorCourse.courseForm.materialsHeader': 'Υλικό κύκλου μαθημάτων',
  'aet.instructorCourse.courseForm.resolveError': 'Δεν μπορέσαμε να φορτώσουμε το υλικό του κύκλου μαθημάτων. Προσπάθησε ξανά.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Πρόσφατα προβεβλημένα',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Προστέθηκαν πρόσφατα',
  'aet.instructorCourse.coursesSort.aToZ': 'A προς Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z προς A',
  'aet.instructorCourse.manageRoster.column.name': 'Όνομα',
  'aet.instructorCourse.manageRoster.column.role': 'Ρόλος',
  'aet.instructorCourse.manageRoster.column.email': 'Με email',
  'aet.instructorCourse.manageRoster.column.status': 'Κατάσταση',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Μαθητής',
  'aet.instructorCourse.roster.role.ta': 'TA',
  'aet.instructorCourse.roster.role.instructor': 'Εκπαιδευτικός',
  'aet.instructorCourse.roster.status.active': 'Ενεργά',
  'aet.instructorCourse.roster.status.inactive': 'Ανενεργά',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Όλα τα μέλη',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Ενεργοί μαθητές',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Ανενεργοί μαθητές',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Βοηθός διδασκαλίας (TA)',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Εκπαιδευτικός',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Συγγραφέας:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Ημερομηνία δημιουργίας κύκλου μαθημάτων:',
  'aet.instructorCourse.noCoursesFound': 'Δεν βρέθηκε κανένας κύκλος μαθημάτων.',
  'aet.instructorCourse.backButton': 'Πίσω',
  'aet.instructorCourse.selectCourse': 'Επιλογή κύκλου μαθημάτων',
  'aet.home.linkedToLms': 'Σε σύνδεση με το LMS',
  'aet.instructorCourse.courseForm.title.create': 'Δημιουργία κύκλου μαθημάτων',
  'aet.instructorCourse.courseForm.title.copy': 'Αντιγραφή κύκλου μαθημάτων',
  'aet.instructorCourse.courseForm.title.edit': 'Πληροφορίες για τον κύκλο μαθημάτων',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Εργασίες',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Περιεχόμενο εργασίας',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Προθεσμίες εργασιών',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Επισημάνσεις και σημειώσεις',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Χρώμα επισήμανσης',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Κείμενο σημείωσης',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Κοινοποιημένη κατάσταση',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Κατάλογος ονομάτων μαθητών και συμμετοχή',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Ονόματα μαθητών',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Διευθύνσεις email',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Εγγραφές',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Ολοκλήρωση και πληροφορίες',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Ρυθμίσεις',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Αντιγραμμένα δεδομένα',
  'aet.studentRoster.manageStudentRosterButton': 'Διαχείριση καταλόγου ονομάτων μαθητών',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Εξαγωγή προόδου μαθητή',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Κατάσταση:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Γράφτηκε:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Ρόλος:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Ως βοηθός διδασκαλίας, το άτομο αυτό θα μπορεί να βλέπει την πρόοδο και τις επιδόσεις όλων των μαθητών στην τάξη αυτή.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Επίσης, θα μπορεί να διαχειρίζεται τους μαθητές και τις εργασίες, αλλά δεν θα μπορεί να διαγράψει την τάξη.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Προώθηση στον βοηθό διδασκαλίας',
  'aet.home.manageRoster.searchPlaceholder': 'Αναζήτηση για μαθητή',
  'aet.home.manageRoster.inactivateButtonLabel': 'Απενεργοποίηση επιλεγμένων μαθητών',
  'aet.home.manageRoster.FilterLabel': 'Εμφάνιση',
  'aet.home.manageRoster.updatingMessage': 'Ενημέρωση καταλόγου ονομάτων... Ενδέχεται να διαρκέσει λίγα λεπτά.',
  'aet.home.courses.search.searchPlaceHolder': 'Αναζήτηση των κύκλων μαθημάτων σου',
  'aet.courses.emptyStateDescription': 'Άρχισε να χτίζεις τον κύκλο μαθημάτων σου επιλέγοντας μια δυνατότητα παρακάτω.',
  'nativePromoBanner.continueInBrowser': 'Συνέχεια στο πρόγραμμα περιήγησης',
  'globalnav.tooltip.hideNavText': 'Απόκρυψη περιήγησης',
  'globalnav.tooltip.showNavText': 'Εμφάνιση περιήγησης',
  'aet.syllabus.progressTitle': 'Εξαγωγή...',
  'aet.syllabus.progressDesc': 'Περίμενε λίγο όσο επεξεργαζόμαστε το πρόγραμμα σπουδών σου.',
  'aet.syllabus.uploadInputLabel': 'Μετάφερε και απόθεσε αρχεία ή κάνε κλικ για να τα μεταφορτώσεις.',
  'aet.syllabus.uploadSyllabusTabLabel': 'Μεταφόρτωση προγράμματος σπουδών',
  'aet.syllabus.dateAdjusterTabLabel': 'Ρύθμιση ημερομηνίας',
  'aet.syllabus.addManuallyTabLabel': 'Προσθήκη μη αυτόματα',
  'aet.syllabus.addEditLaterText': 'Μπορείς πάντα να προσθέσεις και να επεξεργαστείς εργασίες αργότερα.',
  'aet.syllabus.editAssignmentLabel': 'Επεξεργασία εργασίας',
  'aet.syllabus.addAssignmentLabel': 'Προσθήκη εργασίας',
  'aet.syllabus.assignmentTitleLabel': 'Τίτλος εργασίας',
  'aet.syllabus.dueDateLabel': 'Προθεσμία',
  'aet.syllabus.editDueDateLabel': 'Επεξεργασία προθεσμίας',
  'aet.syllabus.chaptersCoveredLabel': 'Επίλεξε τα κεφάλαια ή τις ενότητες που θέλεις να καλύψεις.',
  'aet.syllabus.updateCtaLabel': 'Ενημέρωση εργασίας',
  'aet.syllabus.addCtaLabel': 'Προσθήκη εργασίας',
  'aet.syllabus.uploadLabel': 'Μεταφόρτωση',
  'aet.syllabus.confirmLabel': 'Επιβεβαίωση',
  'aet.syllabus.updateDatesLabel': 'Ημερομηνία ενημέρωσης',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': 'Διαγραφή εργασίας;',
  'aet.deleteAssignmentTitleMultiple': 'Διαγραφή εργασιών;',
  'aet.deleteAssignmentWarning': 'Η ενέργεια αυτή δεν θα μπορεί να αναιρεθεί και όλα τα συσχετισμένα υποβληθέντα στοιχεία και δεδομένα μαθητών δεν θα είναι πλέον ορατά.',
  'aet.deleteAssignmentKeepCTA': 'Διατήρηση εργασίας',
  'aet.deleteAssignmentDeleteCTA': 'Διαγραφή',
  'aet.assignments.loadingAsset': 'Φόρτωση πόρου...',
  'aet.assignments.allCaughtUpDescription': 'Καμία εργασία για ολοκλήρωση αυτή την εβδομάδα.',
  'aet.assignments.progressTitle': 'Πρόοδος',
  'aet.assignments.performanceTitle': 'Σιγουριά',
  'aet.assignments.completionTitle': 'Ολοκλήρωση',
  'aet.assignments.statusTitle': 'Κατάσταση',
  'aet.assignments.addTooltip': 'Προσθήκη εργασίας',
  'aet.assignments.deleteTooltip': 'Διαγραφή επιλεγμένων εργασιών',
  'aet.assignments.selectToDeleteLabel': 'Λειτουργία επιλογής και διαγραφής',
  'aet.assignments.bulkEditTooltip': 'Μαζική επεξεργασία εργασιών',
  'aet.assignments.title': 'Εργασίες',
  'aet.assignments.assignmentTitle': 'Εργασία',
  'aet.assignments.dueDate': 'Προθεσμία',
  'aet.tabular.searchPlaceholder.assignments': 'Αναζήτηση εργασιών',
  'aet.tabular.searchPlaceholder.students': 'Αναζήτηση μαθητών',
  'aet.tabular.searchPlaceholder.questions': 'Αναζήτηση ερωτήσεων',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Ένας ή περισσότεροι μαθητές έχουν παρατάσεις προθεσμιών για όλες τις εργασίες.',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Ένας ή περισσότεροι μαθητές έχουν παρατάσεις προθεσμίας για την εργασία αυτή.',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Σε έναν ή περισσότερους μαθητές έχουν δοθεί παρατάσεις προθεσμιών. Αναζήτησε το εικονίδιο «Πληροφορίες» για να εντοπίσεις αυτές τις εργασίες.',
  'aet.home.loading': 'Φόρτωση...',
  'aet.home.errorFetchingAssignments': 'Σφάλμα κατά τη λήψη των εργασιών',
  'aet.home.dueThisWeekTitle': 'Με προθεσμία αυτή την εβδομάδα',
  'aet.home.allCaughtUpTitle': 'Ολοκλήρωσες τα πάντα!',
  'aet.home.allCaughtUpDescription': 'Καμία εργασία για ολοκλήρωση αυτή την εβδομάδα.',
  'aet.home.suggestedRemediationTitle': 'Προτεινόμενη επανεξέταση από το Study Prep',
  'aet.home.noSuggestedRemediationTitle': 'Δεν υπάρχει υλικό για προτεινόμενη επανεξέταση.',
  'aet.home.noSuggestedRemediationDescription': 'Έλεγξε και πάλι εδώ μετά την επόμενη εργασία σου.',
  'aet.home.assignmentIncludesTitle': 'Η εργασία περιλαμβάνει',
  'aet.home.sectionsLabel': 'Κεφάλαιο(-α)',
  'aet.home.questionsCount': '{count} ερωτήσεις',
  'aet.home.dueLabel': 'Προθεσμία: {dueDate}',
  'aet.home.due': 'Προθεσμία:',
  'aet.home.progressCompletedLabel': 'Ολοκληρώθηκαν',
  'aet.home.progressCompletedPastDueLabel': 'Ολοκληρώθηκαν εκπρόθεσμα',
  'aet.home.progressInProgressLabel': 'Σε εξέλιξη',
  'aet.home.progressNotStartedLabel': 'Δεν άρχισαν',
  'aet.home.progressCountOfTotal': '{count} από {total}',
  'aet.home.NotAttemptedLabel': 'Χωρίς προσπάθεια',
  'aet.home.questionsTotalLabel': 'Συνολικές ερωτήσεις',
  'aet.home.progressCompletedOnTimeLabel': 'Ολοκληρώθηκε έγκαιρα',
  'aet.home.segmentGreatLabel': 'Ωραία',
  'aet.home.segmentGettingThereLabel': 'Εντάξει',
  'aet.home.segmentNeedsReviewLabel': 'Χρειάζεται δουλειά.',
  'aet.home.segmentOkayLabel': 'Εντάξει',
  'aet.home.editAssignmentTooltip': 'Επεξεργασία εργασίας',
  'aet.home.deleteAssignmentTooltip': 'Διαγραφή εργασίας',
  'aet.home.viewDetailsButton': 'Προβολή λεπτομερειών',
  'aet.home.viewAsStudentButton': 'Προβολή με την ιδιότητα μαθητή',
  'aet.home.welcomeButtonText': 'Έναρξη →',
  'aet.review.emptyStateTitle': 'Τίποτε για ανασκόπηση',
  'aet.review.emptyStateDescription': 'Έλεγξε και πάλι εδώ μετά την επόμενη εργασία σου.',
  'aet.dashboard.tabs.upNext': 'Αμέσως μετά',
  'aet.dashboard.tabs.welcome': 'Καλώς όρισες.',
  'aet.dashboard.tabs.assignments': 'Εργασίες',
  'aet.dashboard.tabs.review': 'Ανασκόπηση',
  'aet.dashboard.tabs.studentRoster': 'Μαθητές',
  'aet.dashboard.classSchedule': 'Πρόγραμμα τάξης:',
  'aet.syllabus.dueTimeLabel': 'Προθεσμία',
  'hero.accessEducatorGuides': 'Πρόσβαση σε οδηγούς εκπαιδευτικών',
  'aet.assignment.save': 'Αποθήκευση',
  'aet.assignment.saveAndAdd': 'Αποθήκευση και προσθήκη άλλης',
  'aet.assignment.delete': 'Διαγραφή',
  'aet.assignment.saveAndClose': 'Αποθήκευση και κλείσιμο',
  'aet.studentRoster.title': 'Μαθητές',
  'aet.studentRoster.titlev1': 'Μαθητής',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Προθεσμίες',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Τυπική',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 ημέρες',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 ημέρες',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 ημέρες',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 εβδομάδα',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 εβδομάδες',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Τελευταία ημέρα της τάξης',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} εργασίες ενημερώθηκαν.',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Δεν ήταν δυνατή η αυτόματη ενημέρωση των εκπρόθεσμων εργασιών. Επεξεργάσου καθεμιά για να καθορίσεις νέα προθεσμία.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Δεν είναι δυνατή η ενημέρωση των προθεσμιών.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Όλες οι εργασίες είναι εκπρόθεσμες και δεν ήταν δυνατή η αυτόματη ενημέρωσή τους. Επεξεργάσου καθεμιά για να καθορίσεις νέα προθεσμία.',
  'aet.bulkEdit.bulkSplitInstruction': 'Θα διαιρέσουμε ομοιόμορφα τις εργασίες σου.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Προθεσμία πρώτης εργασίας',
  'aet.bulkEdit.lastAssignmentDue': 'Προθεσμία τελευταίας εργασίας',
  'aet.bulkEdit.assignmentsDueDays': 'Ποιες ημέρες θέλεις ως προθεσμίες για τις εργασίες;',
  'aet.bulkEdit.addEditLaterText': 'Χρησιμοποιούμε την τεχνολογία AI για τη δημιουργία εργασιών. Μπορείς πάντα να προσθέσεις και να επεξεργαστείς εργασίες αργότερα.',
  'aet.bulkEdit.monday': 'Δευτέρα',
  'aet.bulkEdit.tuesday': 'Τρίτη',
  'aet.bulkEdit.wednesday': 'Τετάρτη',
  'aet.bulkEdit.thursday': 'Πέμπτη',
  'aet.bulkEdit.friday': 'Παρασκευή',
  'aet.bulkEdit.saturday': 'Σάββατο',
  'aet.bulkEdit.sunday': 'Κυριακή',
  'aet.toast.assignmentCreated.title': 'Η εργασία δημιουργήθηκε!',
  'aet.toast.assignmentCreated.single': 'Ονομάστηκε αυτόματα {assignmentTitle}.',
  'aet.toast.assignmentCreated.multiple': '{count} εργασίες έχουν δημιουργηθεί.',
  'aet.toast.assignmentUpdated.title': 'Επιτυχής ενημέρωση.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} έχει ενημερωθεί.',
  'aet.toast.assignmentUpdated.multiple': '{count} εργασίες έχουν ενημερωθεί.',
  'aet.toast.viewAssignment': 'Προβολή εργασίας',
  'aet.toast.viewAssignments': 'Προβολή εργασιών',
  'aet.welcome.title': 'Το ηλεκτρονικό βιβλίο σου της Pearson είναι πλέον συνδεδεμένο με το πρόγραμμα LMS σου.',
  'aet.welcome.LMSAccounTitle': 'Εξερεύνηση δεδομενικών πληροφοριών',
  'aet.welcome.LMSAccounDescription': 'Δες σε ποια ακριβώς θέματα δυσκολεύεται η τάξη σου.',
  'aet.welcome.createAssignmentsTitle': 'Δημιουργία εργασιών',
  'aet.welcome.createAssignmentsDescription': 'Εκχώρησε κεφάλαια μη αυτόματα ή μεταφορτώνοντας το πρόγραμμα σπουδών σου.',
  'aet.welcome.progressViewTitle': 'Παρακολούθηση επιδόσεων στο LMS σου',
  'aet.welcome.progressViewDescription': 'Επίλεξε ρυθμίσεις συγχρονισμού βαθμολογίας στο πρόγραμμα LMS σου.',
  'aet.assignmentDetails.noAssignmentFound': 'Δεν βρέθηκε καμία εργασία.',
  'aet.assignments.loadingErrorTitle': 'Δεν είναι δυνατή η φόρτωση της εργασίας αυτή τη στιγμή.',
  'aet.assignments.loadingErrorDescription': 'Δοκίμασε να κάνεις ανανέωση ή έλεγξε και πάλι αργότερα.',
  'aet.assignmentStudentDetails.noDataFound': 'Δεν υπάρχουν δεδομένα ακόμη.',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Δεν έχουν εγγραφεί μαθητές.',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Οι μαθητές θα εγγραφούν στην τάξη σου μόλις αγοράσουν το ηλεκτρονικό βιβλίο.',
  'aet.home.editAssignmentTooltipDisabled': 'Δεν είναι δυνατή η επεξεργασία: Η εργασία του μαθητή είναι σε εξέλιξη.',
  'aet.home.deleteAssignmentTooltipDisabled': 'Δεν είναι δυνατή η διαγραφή: Η εργασία του μαθητή είναι σε εξέλιξη.',
  'aet.home.StudentDetails.questions': 'Ερωτήσεις',
  'aet.home.StudentDetails.attempts': 'Προσπάθειες',
  'aet.home.StudentDetails.comprehension': 'Σιγουριά',
  'hero.titleInfo.tooltip': 'Πληροφορίες για τον τίτλο',
  'aet.home.publishAssignments': 'Δημοσίευση όλων των εργασιών',
  'aet.dashboard.footer': 'Κάποιο περιεχόμενο δημιουργήθηκε με χρήση AI βάσει του διδακτικού υλικού της Pearson. Παρόλο που η Pearson έχει μια διαδικασία επικύρωσης των αποτελεσμάτων, η παραγωγική τεχνητή νοημοσύνη (AI) ενδέχεται να εξακολουθεί να δίνει ανακριβείς πληροφορίες για πρόσωπα, τόπους ή γεγονότα.',
  'aet.home.bulkEditTitle': 'Μαζική επεξεργασία εργασιών',
  'aet.home.bulkEditSubtitle': 'Κάνε τις αλλαγές σου στο πρόγραμμα σπουδών σου και ύστερα επαναφόρτωσέ το εδώ. Οι εργασίες σου και οι προθεσμίες θα ενημερωθούν αντίστοιχα.',
  'aet.home.createAssignmentTitle': 'Δημιουργία εργασιών',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Συμπεριλαμβάνονται σε κάποια άλλη εργασία.',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Ορισμένες ενότητες συμπεριλαμβάνονται σε κάποια άλλη εργασία.',
  'aet.welcome.welcome.Title': 'Καλώς όρισες!',
  'aet.home.student.roaster.ProgressTitle': 'Συνολική ολοκλήρωση',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Έλεγξε και πάλι εδώ μόλις οι μαθητές αρχίσουν την εργασία.',
  'aet.home.whatDueThisWeekTitle': 'Να τι έχεις να παραδώσεις αυτή την εβδομάδα',
  'aet.assignments.edit.errorTitle': '{count} εργασίες έχουν λάθη.',
  'aet.assignments.edit.errorSubTitle': 'Δεν είναι δυνατή η δημοσίευση εργασιών με λάθη. Επεξεργάσου τες ή μην τις συμπεριλάβεις στη δημοσίευση.',
  'aet.assignments.edit.publishAnyway': 'Δημοσίευση οπωσδήποτε',
  'aet.assignments.edit.editAssignments': 'Επεξεργασία εργασιών',
  'aet.assignments.edit.validationInfoToolTip': 'Επεξεργασία εργασίας για αφαίρεση λαθών',
  'aet.assignments.error.assignmentCreated.title': 'Όλες οι εργασίες έχουν λάθη.',
  'aet.assignments.error.assignmentCreated.description': 'Δεν είναι δυνατή η δημοσίευση εργασιών με λάθη. Επεξεργάσου τες ή δοκίμασε να χρησιμοποιήσεις διαφορετικό πρόγραμμα σπουδών.',
  'aet.assignments.error.uploadSyllabus': 'Μεταφόρτωση προγράμματος σπουδών',
  'aet.assignments.error.editAssignments': 'Επεξεργασία εργασιών',
  'aet.mondly.title': 'Γλώσσες',
  'aet.studentRoster.errorState.title': 'Η λίστα των μαθητών δεν είναι διαθέσιμη.',
  'aet.studentRoster.errorState.description': 'Δεν μπορέσαμε να φορτώσουμε τη λίστα των μαθητών σου. Δοκίμασε να κάνεις ανανέωση ή έλεγξε και πάλι αργότερα.',
  'aet.assignments.sectionLabel': 'ενότητα(-ες)',
  'aet.assignments.questionsLabel': 'ερώτηση(-εις)',
  'aet.assignments.assignmentsLabel': 'εργασία(-ες)',
  'aet.assignments.performanceProgressBar': 'Γραμμή προόδου επιδόσεων',
  'aet.assignments.completionProgressBar': 'Γραμμή προόδου ολοκλήρωσης',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Σίγουρα θέλεις να διαγραφεί η εργασία αυτή;',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Σίγουρα θέλεις να διαγραφούν οι εργασίες αυτές;',
  'aet.home.nextAssignmentTitle': 'Επόμενη εργασία',
  'aet.home.courseSettings': 'Ρυθμίσεις κύκλου μαθημάτων',
  'aet.home.pearsonETextbookResources': 'Πόροι του Pearson+ για το ηλεκτρονικό βιβλίο',
  'aet.home.etextbookInformation': 'Πληροφορίες για το ηλεκτρονικό βιβλίο',
  'aet.multiple.deleteAssignmentKeepCTA': 'Διατήρηση εργασίας(-ών)',
  'aet.syllabus.processingText.header': 'Οργανώνουμε τις ανατεθειμένες εργασίες της τάξης σου – η διαδικασία αυτή θα διαρκέσει πολύ λίγο.',
  'aet.syllabus.processingText.uploading': 'Μεταφόρτωση του εγγράφου σου σε εξέλιξη',
  'aet.syllabus.processingText.activating': 'Ενεργοποίηση στοιχείων AI σε εξέλιξη',
  'aet.syllabus.processingText.extracting': 'Εξαγωγή εργασιών ανάγνωσης σε εξέλιξη',
  'aet.syllabus.processingText.mapping': 'Αντιστοίχιση με το περιεχόμενο του βιβλίου σε εξέλιξη',
  'aet.syllabus.processingText.finishing': 'Διαδικασία ολοκλήρωσης σε εξέλιξη',
  'aet.syllabus.uploadErrorMessage': 'Βεβαιώσου ότι το αρχείο σου PDF ή .docx είναι μικρότερο από 10 MB και ότι η σύνδεσή σου στο Ίντερνετ είναι σταθερή.',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Προσπάθησε ξανά.',
  'aet.syllabus.selectChapterWithQuestions': 'Επίλεξε ένα κεφάλαιο με ερώτηση(-εις).',
  'preferenceSetting.subTitle': 'Οι ρυθμίσεις αυτές θα είναι οι προεπιλεγμένες για όλους τους μαθητές στον συγκεκριμένο κύκλο μαθημάτων.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Διαδράσεις με χρήση AI',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Ενεργοποίηση εργαλείου μελέτης με χρήση AI και περιλήψεων με χρήση AI στα αποτελέσματα της αναζήτησης',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Εμφάνιση πόρων του Study Prep που αφορούν το βιβλίο αυτό',
  'aet.syllabus.footer': 'Η δυνατότητα δημιουργίας εργασιών παρέχεται από την τεχνολογία AI.',
  'aet.dashboard.footerDialogDeatils': 'Για τη δημιουργία ερωτήσεων στις εργασίες με βάση το διδακτικό υλικό της Pearson, χρησιμοποιείται παραγωγική τεχνητή νοημοσύνη (AI). Παρόλο που η Pearson έχει μια διαδικασία επικύρωσης των αποτελεσμάτων, η παραγωγική τεχνητή νοημοσύνη (AI) ενδέχεται να εξακολουθεί να δίνει ανακριβείς πληροφορίες για πρόσωπα, τόπους ή γεγονότα. Η τεχνολογία AI χρησιμοποιείται και για την ομαδοποίηση περιεχομένου στις εργασίες, με βάση το πρόγραμμα σπουδών και/ή το χρονοδιάγραμμα που παρέχεις.',
  'aet.review.footer': 'Δημιουργημένα με χρήση AI',
  'aet.footerCard.dismiss': 'Ματαίωση',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Το Study Prep είναι ένα πρόσθετο εργαλείο που υποστηρίζει τη μάθηση παρέχοντας στους μαθητές βίντεο και προβλήματα εξάσκησης ειδικά προσαρμοσμένα στον συγκεκριμένο κύκλο μαθημάτων.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Ενδέχεται να ζητηθεί από τους μαθητές που το πρόγραμμα πρόσβασής τους δεν περιλαμβάνει το Study Prep να αποκτήσουν τη σχετική συνδρομή προκειμένου να συνεχίσουν να χρησιμοποιούν τους πόρους του Study Prep.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Οι μαθητές που έχουν ήδη αγοράσει το Study Prep δεν θα επηρεαστούν από τη ρύθμιση αυτή.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Περισσότερες πληροφορίες για τα πλεονεκτήματα του Study Prep',
  'aet.home.viewCourseId': 'Προβολή αναγνωριστικού του κύκλου μαθημάτων:',
  'aet.home.copy': 'Αντιγραφή',
  'aet.home.copied': 'Αντιγράφηκε.',
  'aet.home.courseLabel': 'Αναγνωριστικό κύκλου μαθημάτων:',
  'schoolInfoCard.addUniversity': 'Προσθήκη σχολής',
  'schoolInfoCard.title': 'Πληροφορίες για το σχολείο',
  'schoolInfoCard.titleV1': 'Πες μας για τον κύκλο των μαθημάτων σου.',
  'schoolInfoCard.cta': 'Έναρξη',
  'schoolInfoCard.pickInstitution': 'Επιλογή σχολής',
  'schoolInfoCard.addUniversityTitle': 'Προσθήκη του σχολείου σου',
  'schoolInfoCard.addUniversitySubtitle': 'Αν γνωρίζουμε το σχολείο σου και τον κύκλο μαθημάτων σου, έχουμε τη δυνατότητα να σου συνιστούμε το πιο χρήσιμο υλικό μελέτης.',
  'schoolInfoCard.searchPlaceholder': 'Αναζήτηση για το σχολείο σου...',
  'schoolInfoCard.skip': 'Παράλειψη του βήματος αυτού',
  'schoolInfoCard.nextStep': 'Επόμενο βήμα',
  'schoolInfoCard.notInList': 'Το σχολείο μου δεν είναι στη λίστα.',
  'schoolInfoCard.noResults': 'Δεν βρέθηκε κανένα σχολείο που να αντιστοιχεί με την αναζήτησή σου.',
  'schoolInfoCard.noResultsHeading': 'Δεν μπορείς να βρεις το σχολείο σου;',
  'schoolInfoCard.noResultsInstruction': 'Καταχώρησε την πλήρη ονομασία παρακάτω.',
  'schoolInfoCard.noResultsInputPlaceholder': 'Ονομασία σχολείου',
  'schoolInfoCard.addInstitutionLabel': 'Προσθήκη του σχολείου αυτού',
  'aet.assignments.assignmentTitlePlaceholder': 'Καταχώρησε έναν τίτλο.',
  'aet.assignments.titleValidation.titleRequired': 'Απαιτείται τίτλος εργασίας.',
  'aet.assignments.titleValidation.titleTooLong': 'Ο τίτλος της εργασίας δεν μπορεί να έχει πάνω από {0} χαρακτήρες.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Ο τίτλος της εργασίας περιέχει μη υποστηριζόμενους χαρακτήρες.',
  'aet.assignments.titleValidation.titleDuplicate': 'Ο τίτλος της εργασίας ήδη υπάρχει.',
  'aet.syllabus.timeZoneLabel': 'Ζώνη ώρας',
  'aet.review.reviewReadingFromAssignments': 'Διάβασμα ανασκόπησης από εργασία',
  'aet.assignments.chaptersLabel': 'κεφάλαιο(-α)',
  'menu.myAccount.subTitle': 'Το πεδίο για το ίδρυμά σου είναι εδώ.',
  'menu.myAccount.subTitleNotAvailable': 'Μπορείς να προσθέσεις το ίδρυμα εδώ αργότερα ανά πάσα στιγμή.',
  'schoolInfoCard.toastMessage': 'Το πανεπιστήμιο αποθηκεύτηκε.',
  'aet.review.threeDotMenu.askAI': 'Υποβολή ερώτησης στο εργαλείο AI',
  'aet.home.suggestedRemediationSubtitle': 'Παρακολούθησε σχετικά βίντεο και εξασκήσου για να εμπεδώσεις τα θέματα του κύκλου μαθημάτων σου.',
  'aet.home.laggedQuestionLabel': 'Ερωτήσεις με σημαία',
  'aet.home.correctAnswer': 'Σωστή απάντηση',
  'aet.home.incorrectAnswer': 'Η συνηθέστερη λανθασμένη απάντηση',
  'aet.home.behaviourTrendsLabel': 'Δεδομενικές πληροφορίες για την ερώτηση',
  'aet.home.strugglingStudentsLabel': 'Μαθητές που δυσκολεύονται',
  'aet.home.patternsInStudensAiLabel': 'Μοτίβα χρήσης τεχνολογίας AI από τους μαθητές',
  'aet.home.questionLabel': 'Ερώτηση',
  'aet.home.studentAskingSimilarQuestions': 'Μαθητές που κάνουν παρόμοιες ερωτήσεις',
  'aet.home.assignmentDifficultQuestions': 'Δύσκολες ερωτήσεις',
  'aet.home.behaviorTrends': 'Δεδομενικές πληροφορίες για την ερώτηση',
  'aet.home.behaviors': 'Δείκτες επιδόσεων',
  'aet.home.mostDifficultTopics': 'Οι πιο δύσκολες ερωτήσεις',
  'aet.home.commentsFromStudentLabel': 'Σχόλια από μαθητές',
  'aet.home.disregard': 'Παράβλεψη',
  'aet.home.reportAsInaccurate': 'Αναφορά ως ανακριβούς',
  'aet.home.Flagged': 'Με σημαία',
  'aet.home.reportQuestionTitle': 'Αναφορά ερώτησης',
  'aet.home.reportQuestionLabel': 'Τι πρόβλημα υπήρχε στην ερώτηση αυτή;',
  'aet.home.showComments': 'Εμφάνιση σχολίων',
  'aet.home.studentReports': 'αναφορές μαθητών',
  'aet.home.placeholderText': 'Σε παρακαλώ να εξηγήσεις...',
  'aet.home.reportQuestion.notRelevant': 'Μη σχετική',
  'aet.home.reportQuestion.notCorrect': 'Λανθασμένη',
  'aet.home.reportQuestion.unsafe': 'Μη ασφαλής/Επιβλαβής',
  'aet.home.reportQuestion.somethingElse': 'Κάτι άλλο',
  'aet.home.StudentDetails.assistedByAI': 'Με τη βοήθεια της τεχνολογίας AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Κανένας μαθητής δεν δυσκολεύεται αυτή τη στιγμή.',
  'aet.home.strugglingStudents.emptyStateDescription': 'Έλεγξε και πάλι εδώ αργότερα.',
  'aet.home.overallStatus.excelling': 'Αριστεία',
  'aet.home.overallStatus.fallingBehind': 'Υστέρηση',
  'aet.home.overallStatus.keepingUp': 'Τα καταφέρνει.',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Εμφάνιση μόνο της κατηγορίας «Δύσκολες ερωτήσεις»',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Εμφάνιση μόνο της κατηγορίας «Μαθητές που δυσκολεύονται»',
  'aet.home.viewQuestionInAssignment': 'Προβολή ερώτησης στην εργασία',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Λανθασμένες πρώτες προσπάθειες',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Πολλαπλές λανθασμένες προσπάθειες',
  'aet.home.insightRisk.lowConfidence': 'Χαμηλή σιγουριά',
  'aet.home.insightRisk.mediumConfidence': 'Μέτρια σιγουριά',
  'aet.home.insightRisk.lowEngagement': 'Χαμηλή συμμετοχή',
  'aet.home.insightRisk.countOfStudents': '{count} από {total} μαθητές',
  'aet.home.insightRisk.na': 'Δ/Ι',
  'aet.home.strugglingStudentsHereLabel': 'Οι μαθητές δυσκολεύονται εδώ.',
  'aet.home.insightRisk.didNotAttempt': 'Δεν προσπάθησε.',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default el;
